import { Injectable, inject } from '@angular/core';
import { UserService } from 'src/app/core/services/user/user.service';
import { ScrollService } from '../../../services/scroll.service';
import { BurgerService } from '../../../services/burger.service';

@Injectable({
  providedIn: 'root'
})
export class SideNavService {
  _user = inject(UserService);
  private _scroll = inject(ScrollService);
  private _burger = inject(BurgerService);


  public isGamesSubmenu = false;
  public isMoreSubmenu = false;

  /**
   * Sidebar state
   */
  private _isOpen = false;

  /**
   * Access to side-nav state from outside
   */
  get isOpen(): boolean {
    return this._isOpen;
  }

  /**
   * Open side-nav
   */
  public open() {
    if (!this._isOpen) {
      this._scroll.blockScroll();
      this._burger.open();
      setTimeout(() => {
        this._isOpen = true;
      }, 100);
    }
  }

  /**
   * Close side-nav
   */
  public close() {
    if (this._isOpen) {
      this._scroll.UnblockScroll();
      this._burger.close();
      setTimeout(() => {
        this._isOpen = false;
      }, 100);
    }
  }

  /**
   * Toggle side-nav
   */
  public toggle() {
    if (this._isOpen) {
      this.close();
      this._burger.close();
    } else {
      this.open();
      this._burger.open();
    }
  }
}
